import {
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
  Pending as PendingIcon,
  Replay as ReplayIcon,
} from '@mui/icons-material';
import { Chip, Grid, Stack } from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import { ReviewRequest, ReviewStatus } from '../../models/ReviewRequest';
import { Palette } from 'Palette';
import { StyledCard, StyledCardContent, StyledTypography } from '../styles/styles';
import { getReviewStatusColor } from './reviewViewerUtils';

function getStatusIcon(status: ReviewStatus) {
  switch (status) {
    case 'PENDING':
      return <PendingIcon />;
    case 'CHANGES_REQUESTED':
    case 'REVIEW_REJECTED':
      return <ReplayIcon />;
    case 'REVIEW_COMPLETE':
      return <CheckCircleIcon />;
    default:
      return <AssignmentIcon />;
  }
}

interface ReviewViewerHeaderProps {
  tone: keyof typeof Palette;
  reviewRequest: ReviewRequest;
}

export default function ReviewViewerHeader({ tone, reviewRequest }: ReviewViewerHeaderProps) {
  return (
    <StyledCard tone={tone} sx={{ mb: 3 }}>
      <StyledCardContent>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
          {getStatusIcon(reviewRequest.status)}
          <Chip
            label={reviewRequest.status.replace('_', ' ')}
            color={getReviewStatusColor(reviewRequest.status)}
            size="small"
          />
        </Stack>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <StyledTypography tone={tone} variant="body2" color="text.secondary">
              <strong>Requested by:</strong> {reviewRequest.requestedBy.name}
            </StyledTypography>
            <StyledTypography tone={tone} variant="body2" color="text.secondary">
              <strong>Assigned to:</strong> {reviewRequest.requestedOf.name}
            </StyledTypography>
          </Grid>
          <Grid item xs={12} md={6}>
            <StyledTypography tone={tone} variant="body2" color="text.secondary">
              <strong>Created:</strong>{' '}
              {format(new Date(reviewRequest.createdAt), "MMM d, yyyy 'at' h:mm a")}
            </StyledTypography>
            <StyledTypography tone={tone} variant="body2" color="text.secondary">
              <strong>Updated:</strong>{' '}
              {format(new Date(reviewRequest.updatedAt), "MMM d, yyyy 'at' h:mm a")}
            </StyledTypography>
          </Grid>
        </Grid>
      </StyledCardContent>
    </StyledCard>
  );
}
